import clsx from "clsx"
import makeStyles from "@material-ui/core/styles/makeStyles"
import { alpha } from "@material-ui/core"

import MuiMenuItem from "@material-ui/core/MenuItem"
import Checkbox from "@material-ui/core/Checkbox"

import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank"
import CheckBoxIcon from "@material-ui/icons/CheckBox"
import React, { forwardRef } from "react"

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: "#fff"
    },

    faded: {
        backgroundColor: "rgba(120, 160, 0, 0.12) !important",
        color: `${theme.palette.action.disabled} !important`
    },

    selected: {
        fontWeight: 500,
        backgroundColor: `${alpha(theme.palette.primary.main, 0.15)} !important`,

        "& .MuiTypography-body1": {
            fontWeight: `inherit !important`,
            color: theme.palette.text.primary
        }
    }
}))

const MenuItem = props => {
    const classes = useStyles()

    return (
        <MuiMenuItem
            {...props}
            className={clsx({
                [classes.root]: true,
                [classes.selected]: props.selected
            })}
        >
            <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                checked={props.selected}
                color="primary"
            />
            {props.children}
        </MuiMenuItem>
    )
}

const MenuItemRefForwarded = forwardRef((props, ref) => {
    return <MenuItem {...props} innerRef={ref} />
})

export default MenuItemRefForwarded
